export default "__VITE_ASSET__ClNofv7g__"